<template>
  <div class="handicap-chart-container">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

export default {
  name: 'HandicapChart',
  props: {
    scores: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    scores: {
      handler () {
        this.initChart()
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy () {
    if (this.chart) {
      this.chart.destroy()
    }
  },
  methods: {
    initChart () {
      if (!this.$refs.chartCanvas) return

      const ctx = this.$refs.chartCanvas.getContext('2d')
      const data = this.prepareData()

      if (this.chart) {
        this.chart.data = data
        this.chart.update()
      } else {
        this.chart = new ChartJS(ctx, {
          type: 'line',
          data,
          options: {
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
              legend: {
                display: true,
                position: 'top'
              },
              title: {
                display: true,
                text: 'Evolución del Handicap'
              }
            },
            scales: {
              y: {
                beginAtZero: false,
                ticks: {
                  stepSize: 1
                }
              }
            }
          }
        })
      }
    },

    prepareData () {
      if (!this.scores || !this.scores.length) {
        return {
          labels: [],
          datasets: []
        }
      }

      // Ordena por fecha y toma últimas 20
      const sorted = [...this.scores]
        .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
        .slice(-20)

      const labels = sorted.map(s => {
        const date = new Date(s.created_at)
        return date.toLocaleDateString('es-ES', { month: 'short', day: 'numeric' })
      })

      const handicaps = sorted.map(s => parseFloat(s.handicap) || 0)

      return {
        labels,
        datasets: [
          {
            label: 'Handicap',
            data: handicaps,
            borderColor: '#1976d2',
            backgroundColor: 'rgba(25, 118, 210, 0.1)',
            borderWidth: 2,
            fill: true,
            tension: 0.4,
            pointRadius: 4,
            pointBackgroundColor: '#1976d2',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointHoverRadius: 6
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
.handicap-chart-container {
  position: relative;
  height: 300px;
  width: 100%;
}
</style>
